module.exports = __webpack_public_path__ + "media/images/clinician_form-8fc5d355.svg";